module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate-new/design-studio-1f777a41b4334589a64ac17b512727ae.webp";